export enum HelpCenterLocation {
  Portal,
  Flow,
  Form,
  StatementRule,
  TruthTable,
  Matrix,
  Page,
  Reports,
  DataDesigner
}
